<script setup lang="ts">
import CornerRightUpIcon from "@/assets/icons/corner-right-up.svg?component";
import ScaleFrameEnlargeIcon from "@/assets/icons/scale-frame-enlarge.svg?component";
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { SectionNode } from "@/domains/v4b/site-section/site-section.types";
import { useTypedIntl } from "@/locales/typed-intl";

interface IProps {
  section?: SectionNode;
  parentName?: string;
}

const props = defineProps<IProps>();

const { t, k } = useTypedIntl();
</script>

<template>
  <div class="flex gap-2">
    <ScaleFrameEnlargeIcon />
    <div class="flex flex-col gap-1">
      <span
        class="font-medium"
        :data-test-id="DATA_TEST_IDS.components.sectionDetailsReadonlyContent.sectionArea"
        >{{ props.section?.area ?? "-" }} m2</span
      >
      <small class="text-gray-600">
        {{ t(k.tools.siteManagement.sectionDetails.area) }}
      </small>
    </div>
  </div>

  <div class="flex gap-2">
    <i class="pi pi-tag text-text-secondary" />
    <div class="flex flex-col gap-1">
      <span
        class="font-medium"
        :data-test-id="DATA_TEST_IDS.components.sectionDetailsReadonlyContent.sectionCategoryName"
        >{{ props.section?.category?.name ?? "-" }}</span
      >
      <small class="text-gray-600">
        {{ t(k.tools.siteManagement.sectionDetails.category) }}
      </small>
    </div>
  </div>

  <div class="flex gap-2">
    <CornerRightUpIcon />
    <div class="flex flex-col gap-1">
      <span
        class="font-medium"
        :data-test-id="DATA_TEST_IDS.components.sectionDetailsReadonlyContent.sectionParentName"
        >{{ props.parentName ?? "-" }}</span
      >
      <small class="text-gray-600">
        {{ t(k.tools.siteManagement.sectionDetails.parentSection) }}
      </small>
    </div>
  </div>
</template>
